import { IconName } from '@fox/atoms/src/icon/index';

const TreeSelectOperators: {
	icon: IconName;
	filterConstraints: string[];
	humanNames: {
		ARRAY_CONTAINS: string;
		'NOT ARRAY_CONTAINS': string;
	};
} = {
	icon: 'AccountTree',
	filterConstraints: ['ARRAY_CONTAINS', 'NOT ARRAY_CONTAINS'],
	humanNames: {
		ARRAY_CONTAINS: 'include',
		'NOT ARRAY_CONTAINS': 'exclude'
	}
};
export default TreeSelectOperators;
